import { createApp } from 'vue';
import WoffToTtfConverter from '@/Components/WoffToTtfConverter.vue';
import '@styles/app.css';

createApp(WoffToTtfConverter).mount('#woff-to-ttf-converter');
